module.exports = __webpack_public_path__ + "img/c4.ee0bcfda.png";